<ng-container *ngIf="(label$ | async) as label">
    <labeling-task-text-annotate
        *ngIf="((labelingReviewService.currentReviewRecord$ | async) | as: ReviewRecordInfo) as recordInfo"
        [record]="(recordInfo.record | as: TextLabelingRecord)"
        [label]="label" 
        (labelChange)="onLabelChange$.next($event)"
    ></labeling-task-text-annotate>
</ng-container>